import React from 'react'
import SectionTitleS2 from '../SectionTitleS2'
import sImg1 from '../../images/event-shape-1.png'
import sImg2 from '../../images/event-shape-2.png'
import { useLanguage } from '../../contexts/LanguageContext';

const EventSectionInner = (props) => {
    const { t } = useLanguage();
    
    const Events = [
        {
            Simg1: sImg1,
            Simg2: sImg2,
            title: t('events.weddingPlanner'),
            description: t('events.weddingPlannerDescription'),
            phone: '+36 30 329 94 66',
            phoneHref: 'tel:+36303299466',
            centered: true,
        },
        {
            Simg1: sImg1,
            Simg2: sImg2,
            title: t('events.schedule'),
            description: t('events.scheduleDescription'),
        },
        {
            Simg1: sImg1,
            Simg2: sImg2,
            title: t('events.transfer'),
            description: t('events.transferDescription'),
        },
        {
            Simg1: sImg1,
            Simg2: sImg2,
            title: t('events.dressCode'),
            description: t('events.dressCodeDescription'),
        },
        {
            Simg1: sImg1,
            Simg2: sImg2,
            title: t('events.others'),
            description: t('events.othersDescription'),
        },
    ];

    return (
        <section className={`wpo-event-section section-padding ${props.eClass}`} id="events">
            <div className="container">
                <SectionTitleS2 MainTitle={t('events.title')} />
                <div className="wpo-event-wrap">
                    <div className="row">
                        {Events.map((event, eitem) => (
                            <React.Fragment key={eitem}>
                            <div className={`col ${event.centered ? 'col-lg-6 col-md-8 col-12 mx-auto' : 'col-lg-6 col-md-6 col-12'}`}>
                                <div className="wpo-event-item">
                                    <div className="wpo-event-text" style={event.centered ? { textAlign: 'center' } : undefined}>
                                        <h2>{event.title}</h2>
                                        <p style={{ whiteSpace: 'pre-line' }}>{event.description}</p>
                                        {event.phone && (
                                            <p>
                                                <a href={event.phoneHref}>{event.phone}</a>
                                            </p>
                                        )}
                                    </div>
                                    <div className="event-shape-1">
                                        <img src={event.Simg1} alt="" />
                                    </div>
                                    <div className="event-shape-2">
                                        <img src={event.Simg2} alt="" />
                                    </div>
                                </div>
                            </div>
                            {event.centered && <div className="w-100" />}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

const EventSection = (props) => {
    return <EventSectionInner {...props} />;
};

export default EventSection;
